var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('FanAccount',{on:{"onUpdateSelection":_vm.updateSelected}}),_c('ArtistAccount',{on:{"onUpdateSelection":_vm.updateSelected}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }